import { useAuth0 } from '@auth0/auth0-react';
import { apiPath } from '../../../config';

interface FeedbackHandlerReturn {
  sendFeedback: (
    response_id: string,
    feedback: boolean | null,
    itemurl?: string,
    resolve?: boolean,
    currentRanking?: any
  ) => Promise<any>;
}

export const useFeedbackHandler = (): FeedbackHandlerReturn => {
  const { getIdTokenClaims } = useAuth0();

  const sendFeedback = async (
    response_id: string,
    feedback: boolean | null,
    itemurl?: string,
    resolve?: boolean,
    currentRanking?: any
  ) => {
    console.log(
      'sendFeedback-',
      response_id,
      feedback,
      itemurl,
      resolve,
      currentRanking
    );
    try {
      let postData: any = {};
      let text = '';
      if (currentRanking) {
        if (currentRanking.text) {
          text = currentRanking.text;
        }
      }

      if (feedback === null) {
        // Neutral state - remove feedback
        postData = {
          response_id: response_id,
          ratings: {
            thumbs_up: Number(0),
            thumbs_down: Number(0),
            text: text,
          },
        };
      } else if (feedback) {
        postData = {
          response_id: response_id,
          ratings: {
            thumbs_up: Number(1),
            text: text,
          },
        };
      } else {
        postData = {
          response_id: response_id,
          ratings: {
            thumbs_down: Number(1),
            text: text,
          },
        };
      }
      if (itemurl) {
        if (feedback === null) {
          // Neutral state for itemurl - remove feedback
          postData = {
            response_id: response_id,
            url: itemurl,
            likes: 0,
            dislikes: 0,
          };
        } else {
          postData = {
            response_id: response_id,
            url: itemurl,
            likes: feedback ? 1 : 0,
            dislikes: feedback ? 0 : 1,
          };
        }
      }
      if (resolve) {
        postData = {
          response_id: response_id,
          resolve: true,
        };
      }
      postData = JSON.stringify(postData);

      const getidToken = await getIdTokenClaims();
      const idToken = getidToken.__raw;
      const options = {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${idToken}`,
          'Content-Type': 'application/json',
        },
        body: postData,
      };

      const rankPath = `/response/ranking`;
      const url = `${apiPath()}${rankPath}`;
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching data:', error);
      return { error: error };
    }
  };

  return { sendFeedback };
};
